(function () {

  "use strict";


  function vsInitMarketplacePremium(section) {

    if (!section) {
      return;
    }


    const marketplaceCards =
      section.querySelectorAll(
        ".vs-marketplace-premium__marketplace"
      );


    const trustItems =
      section.querySelectorAll(
        ".vs-marketplace-premium__trust-item"
      );


    const allAnimatedItems = [
      ...marketplaceCards,
      ...trustItems
    ];


    /*
     * Initial state
     */

    allAnimatedItems.forEach(
      function (item, index) {

        item.style.opacity = "0";

        item.style.transform =
          "translateY(16px)";

        item.style.transition =
          "opacity .5s ease " +
          (index * 70) +
          "ms, " +
          "transform .5s ease " +
          (index * 70) +
          "ms";

      }
    );


    /*
     * Reveal on scroll
     */

    if (
      "IntersectionObserver" in window
    ) {

      const observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  entry.isIntersecting
                ) {

                  entry.target.style.opacity =
                    "1";

                  entry.target.style.transform =
                    "translateY(0)";

                  observer.unobserve(
                    entry.target
                  );

                }

              }
            );

          },
          {
            threshold: 0.12
          }
        );


      allAnimatedItems.forEach(
        function (item) {

          observer.observe(item);

        }
      );

    } else {

      allAnimatedItems.forEach(
        function (item) {

          item.style.opacity = "1";

          item.style.transform =
            "translateY(0)";

        }
      );

    }

  }


  /*
   * Initial page load
   */

  function vsInitAllMarketplacePremium() {

    document
      .querySelectorAll(
        "[data-vs-marketplace-premium]"
      )
      .forEach(
        function (section) {

          vsInitMarketplacePremium(
            section
          );

        }
      );

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      vsInitAllMarketplacePremium
    );

  } else {

    vsInitAllMarketplacePremium();

  }


  /*
   * Shopify Theme Editor
   */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      const section =
        event.target.querySelector(
          "[data-vs-marketplace-premium]"
        );


      if (section) {

        vsInitMarketplacePremium(
          section
        );

      }

    }
  );


})();